import React from "react";
import * as PropTypes from "prop-types";
import LinkType from "./linkType";
import { Box } from "@chakra-ui/core";
import LinkItem from "./linkItem";

const LinkList = ({ links, ...props }) => {
  if (links) {
    return (
      <Box {...props}>
        {links.map(link => (
          <LinkItem
            key={`${link.type}${link.label}`}
            link={link}
            mr={4}
          />
        ))}
      </Box>
    );
  }
  return null;
};

LinkList.propTypes = {
  links: PropTypes.arrayOf(LinkType),
};

LinkList.defaultProps = {
  links: null,
};

export default LinkList;
